import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Hauwa2 from "../../../assets/shortlist_22/hauwa2.jpg";
import Muazu from "../../../assets/shortlist_22/muazu.jpg";
import Nelson from "../../../assets/shortlist_22/nelson.jpg";
import Olamilekan from "../../../assets/shortlist_22/olamilekan.jpg";

const civicNominees = [
  {
    name: "Hauwa Allahbura",
    title: "PullUpNaija",
    imgpath: Hauwa2,
    story:
      "Pull-up Naija is a concept by the 24 Angels initiative. A community of young Nigerians, breaking the myth that our votes don't count.",
  },
  {
    name: "Muazu Modu",
    title: "Spotlight for Transparency and Accountability",
    imgpath: Muazu,
    story:
      "Spotlight for Transparency and Accountability [ST&A] is a non-government organization (NGO) whose mission is to empower and work with communities to demand for accountability, improved service delivery, and promote democratic governance.",
  },
  {
    name: "Nelson Olanipekun",
    title: "Citizen Gavel",
    imgpath: Nelson,
    story:
      "Citizen Gavel is a not for profit/non-governmental organization with the aim of increasing the pace of justice delivery through access to justice, digital technology and citizens’ engagement.",
  },
  {
    name: "Olamilekan Omidiji",
    title: "Ymonitor",
    imgpath: Olamilekan,
    story:
      "YMonitor accountability project is an initiative under The Future Project (TFP), a developmental organization dedicated to building a network of empowered citizens – through jobs, entrepreneurship and active citizenship.",
  },
];

const CivicNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Award for Civic Activism (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {civicNominees.map((nominate, index) => {
          const { name, title, imgpath, story } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paragraph
                      variant="body2"
                      fontWeight={400}
                      color="#4f4f4f"
                      textAlign={"center"}
                    >
                      {story}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default CivicNominees;
